import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { CrudService } from 'environments/crud.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [ CrudService ]
})
export class AppComponent implements OnInit{
  token  = sessionStorage.getItem('token')
  constructor(
    private crud: CrudService,
    private router: Router
  ){}

  ngOnInit(){
    if(this.token){
      this.crud.getUser(this.token, 'auth/users/me').subscribe(
        response => {
          console.log(response)
        },
        error => {
          this.router.navigate(['/login'])

        }
      )
    }
    else{
      this.router.navigate(['/login'])
    }
  }

}
